"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listenForWorldUpdates = void 0;
const Bank_1 = require("../../classes/Bank");
const Chest_1 = require("../../classes/Chest");
const retrommo_types_1 = require("retrommo-types");
const ItemInstance_1 = require("../../classes/ItemInstance");
const MainMenuCharacter_1 = require("../../classes/MainMenuCharacter");
const NPC_1 = require("../../classes/NPC");
const Player_1 = require("../../classes/Player");
const Quest_1 = require("../../classes/Quest");
const pixel_pigeon_1 = require("pixel-pigeon");
const WorldCharacter_1 = require("../../classes/WorldCharacter");
const state_1 = require("../../state");
const addWorldCharacterEmote_1 = require("../addWorldCharacterEmote");
const addWorldCharacterMarker_1 = require("../addWorldCharacterMarker");
const clearWorldCharacterMarker_1 = require("../clearWorldCharacterMarker");
const closeWorldMenus_1 = require("../world-menus/closeWorldMenus");
const createBattleState_1 = require("../state/createBattleState");
const createMainMenuState_1 = require("../state/main-menu/createMainMenuState");
const definables_1 = require("definables");
const getWorldState_1 = require("../state/getWorldState");
const inventoryWorldMenu_1 = require("../../world-menus/inventoryWorldMenu");
const loadItemInstanceUpdate_1 = require("../load-updates/loadItemInstanceUpdate");
const loadWorldCharacterUpdate_1 = require("../load-updates/loadWorldCharacterUpdate");
const loadWorldNPCUpdate_1 = require("../load-updates/loadWorldNPCUpdate");
const npcDialogueWorldMenu_1 = require("../../world-menus/npcDialogueWorldMenu");
const selectedPlayerWorldMenu_1 = require("../../world-menus/selectedPlayerWorldMenu");
const volumeChannels_1 = require("../../volumeChannels");
const spellbookWorldMenu_1 = require("../../world-menus/spellbookWorldMenu");
const statsWorldMenu_1 = require("../../world-menus/statsWorldMenu");
const updateWorldCharacterOrder_1 = require("../updateWorldCharacterOrder");
const listenForWorldUpdates = () => {
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/accept-quest",
        onMessage: (update) => {
            const worldState = (0, getWorldState_1.getWorldState)();
            const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, worldState.values.worldCharacterID);
            const isLeader = worldCharacter.player.character.party.playerIDs[0] ===
                worldCharacter.id;
            if (npcDialogueWorldMenu_1.npcDialogueWorldMenu.isOpen() === false) {
                (0, closeWorldMenus_1.closeWorldMenus)();
                npcDialogueWorldMenu_1.npcDialogueWorldMenu.open({
                    isLeader,
                    npcID: update.npcID,
                });
            }
            const npc = (0, definables_1.getDefinable)(NPC_1.NPC, update.npcID);
            npcDialogueWorldMenu_1.npcDialogueWorldMenu.state.setValues({
                questCompletion: null,
                selectedQuestIndex: npc.questGiver.quests.findIndex((questGiverQuest) => questGiverQuest.questID === update.questID),
            });
            const quest = (0, definables_1.getDefinable)(Quest_1.Quest, update.questID);
            for (const partyPlayer of worldCharacter.player.character.party.players) {
                const questInstance = partyPlayer.worldCharacter.questInstances[update.questID];
                if (typeof questInstance === "undefined") {
                    partyPlayer.worldCharacter.questInstances[update.questID] = {
                        isCompleted: false,
                        isStarted: false,
                        monsterKills: quest.hasMonster() ? 0 : undefined,
                    };
                }
                const updatedQuestInstance = partyPlayer.worldCharacter.questInstances[update.questID];
                if (typeof updatedQuestInstance === "undefined") {
                    throw new Error("No updated quest instance.");
                }
                if (updatedQuestInstance.isStarted === false) {
                    updatedQuestInstance.isStarted = true;
                }
            }
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/bank-gold",
        onMessage: (update) => {
            const worldState = (0, getWorldState_1.getWorldState)();
            worldState.setValues({
                inventoryGold: update.inventoryGold,
            });
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/bank-items",
        onMessage: (update) => {
            const worldState = (0, getWorldState_1.getWorldState)();
            for (const bagItemInstanceID of worldState.values.bagItemInstanceIDs) {
                const bagItemInstance = (0, definables_1.getDefinable)(ItemInstance_1.ItemInstance, bagItemInstanceID);
                bagItemInstance.remove();
            }
            for (const bagItemInstanceUpdate of update.bagItemInstances) {
                (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(bagItemInstanceUpdate);
            }
            worldState.setValues({
                bagItemInstanceIDs: update.bagItemInstances.map((itemInstanceUpdate) => itemInstanceUpdate.itemInstanceID),
            });
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/bonk",
        onMessage: () => {
            (0, pixel_pigeon_1.playAudioSource)("sfx/bonk", {
                volumeChannelID: volumeChannels_1.sfxVolumeChannelID,
            });
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/buy-shop-item",
        onMessage: (update) => {
            const worldState = (0, getWorldState_1.getWorldState)();
            worldState.setValues({
                bagItemInstanceIDs: [
                    ...worldState.values.bagItemInstanceIDs,
                    update.itemInstance.itemInstanceID,
                ],
                inventoryGold: update.gold,
            });
            new ItemInstance_1.ItemInstance({
                id: update.itemInstance.itemInstanceID,
                itemID: update.itemInstance.itemID,
            });
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/clear-marker",
        onMessage: (update) => {
            (0, clearWorldCharacterMarker_1.clearWorldCharacterMarker)(update.characterID);
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/close-bank",
        onMessage: (update) => {
            const bank = (0, definables_1.getDefinable)(Bank_1.Bank, update.bankID);
            bank.isOpen = false;
            bank.toggledAt = (0, pixel_pigeon_1.getCurrentTime)();
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/combat",
        onMessage: (update) => {
            var _a, _b;
            const worldState = (0, getWorldState_1.getWorldState)();
            for (const bagItemInstanceID of worldState.values.bagItemInstanceIDs) {
                const bagItemInstance = (0, definables_1.getDefinable)(ItemInstance_1.ItemInstance, bagItemInstanceID);
                bagItemInstance.remove();
            }
            for (const boostItemInstanceID of worldState.values
                .boostItemInstanceIDs) {
                const boostItemInstance = (0, definables_1.getDefinable)(ItemInstance_1.ItemInstance, boostItemInstanceID);
                boostItemInstance.remove();
            }
            for (const bagItemInstanceUpdate of update.bagItemInstances) {
                (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(bagItemInstanceUpdate);
            }
            for (const boostItemInstanceUpdate of update.boostItemInstances) {
                (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(boostItemInstanceUpdate);
            }
            worldState.setValues({
                bagItemInstanceIDs: update.bagItemInstances.map((itemInstanceUpdate) => itemInstanceUpdate.itemInstanceID),
                boostItemInstanceIDs: update.boostItemInstances.map((itemInstanceUpdate) => itemInstanceUpdate.itemInstanceID),
            });
            for (const worldCombatCharacter of update.worldCombatCharacters) {
                const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, worldCombatCharacter.characterID);
                worldCharacter.isRenewing = worldCombatCharacter.isRenewing;
                worldCharacter.resources = {
                    hp: worldCombatCharacter.resources.hp,
                    maxHP: worldCombatCharacter.resources.maxHP,
                    maxMP: (_a = worldCombatCharacter.resources.maxMP) !== null && _a !== void 0 ? _a : null,
                    mp: (_b = worldCombatCharacter.resources.mp) !== null && _b !== void 0 ? _b : null,
                };
            }
            if (spellbookWorldMenu_1.spellbookWorldMenu.isOpen() &&
                spellbookWorldMenu_1.spellbookWorldMenu.state.values.isAwaitingWorldCombat) {
                spellbookWorldMenu_1.spellbookWorldMenu.close();
            }
            if (inventoryWorldMenu_1.inventoryWorldMenu.isOpen() &&
                inventoryWorldMenu_1.inventoryWorldMenu.state.values.isAwaitingWorldCombat) {
                inventoryWorldMenu_1.inventoryWorldMenu.close();
            }
            for (const worldCharacter of (0, definables_1.getDefinables)(WorldCharacter_1.WorldCharacter).values()) {
                if (state_1.state.values.selectedPlayerID !== worldCharacter.playerID &&
                    worldCharacter.hasMarkerEntity()) {
                    (0, clearWorldCharacterMarker_1.clearWorldCharacterMarker)(worldCharacter.id);
                }
            }
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/destroy-boost",
        onMessage: (update) => {
            const worldState = (0, getWorldState_1.getWorldState)();
            worldState.setValues({
                boostItemInstanceIDs: worldState.values.boostItemInstanceIDs.filter((boostItemInstanceID) => boostItemInstanceID !== update.itemInstanceID),
            });
            (0, definables_1.getDefinable)(ItemInstance_1.ItemInstance, update.itemInstanceID).remove();
            if (statsWorldMenu_1.statsWorldMenu.isOpen()) {
                statsWorldMenu_1.statsWorldMenu.state.setValues({
                    selectedBoostIndex: null,
                });
            }
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/emote",
        onMessage: (update) => {
            (0, addWorldCharacterEmote_1.addWorldCharacterEmote)(update.characterID, update.emoteID, (0, pixel_pigeon_1.getCurrentTime)());
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/enter-characters",
        onMessage: (update) => {
            for (const worldCharacterUpdate of update.characters) {
                const worldCharacterUpdatePlayer = (0, definables_1.getDefinable)(Player_1.Player, worldCharacterUpdate.playerID);
                worldCharacterUpdatePlayer.worldCharacterID =
                    worldCharacterUpdate.characterID;
                (0, loadWorldCharacterUpdate_1.loadWorldCharacterUpdate)(worldCharacterUpdate);
                if (state_1.state.values.selectedPlayerID === worldCharacterUpdate.playerID) {
                    (0, addWorldCharacterMarker_1.addWorldCharacterMarker)(worldCharacterUpdate.characterID, retrommo_types_1.MarkerType.Selected);
                }
            }
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/equipment",
        onMessage: (update) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const worldState = (0, getWorldState_1.getWorldState)();
            for (const bagItemInstanceID of worldState.values.bagItemInstanceIDs) {
                const bagItemInstance = (0, definables_1.getDefinable)(ItemInstance_1.ItemInstance, bagItemInstanceID);
                bagItemInstance.remove();
            }
            if (worldState.values.bodyItemInstanceID !== null) {
                const bodyItemInstance = (0, definables_1.getDefinable)(ItemInstance_1.ItemInstance, worldState.values.bodyItemInstanceID);
                bodyItemInstance.remove();
            }
            if (worldState.values.headItemInstanceID !== null) {
                const headItemInstance = (0, definables_1.getDefinable)(ItemInstance_1.ItemInstance, worldState.values.headItemInstanceID);
                headItemInstance.remove();
            }
            if (worldState.values.mainHandItemInstanceID !== null) {
                const mainHandItemInstance = (0, definables_1.getDefinable)(ItemInstance_1.ItemInstance, worldState.values.mainHandItemInstanceID);
                mainHandItemInstance.remove();
            }
            if (worldState.values.offHandItemInstanceID !== null) {
                const offHandItemInstance = (0, definables_1.getDefinable)(ItemInstance_1.ItemInstance, worldState.values.offHandItemInstanceID);
                offHandItemInstance.remove();
            }
            for (const bagItemInstanceUpdate of update.bagItemInstances) {
                (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(bagItemInstanceUpdate);
            }
            if (typeof update.bodyItemInstance !== "undefined") {
                (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.bodyItemInstance);
            }
            if (typeof update.headItemInstance !== "undefined") {
                (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.headItemInstance);
            }
            if (typeof update.mainHandItemInstance !== "undefined") {
                (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.mainHandItemInstance);
            }
            if (typeof update.offHandItemInstance !== "undefined") {
                (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.offHandItemInstance);
            }
            worldState.setValues({
                bagItemInstanceIDs: update.bagItemInstances.map((itemInstanceUpdate) => itemInstanceUpdate.itemInstanceID),
                bodyItemInstanceID: (_b = (_a = update.bodyItemInstance) === null || _a === void 0 ? void 0 : _a.itemInstanceID) !== null && _b !== void 0 ? _b : null,
                headItemInstanceID: (_d = (_c = update.headItemInstance) === null || _c === void 0 ? void 0 : _c.itemInstanceID) !== null && _d !== void 0 ? _d : null,
                mainHandItemInstanceID: (_f = (_e = update.mainHandItemInstance) === null || _e === void 0 ? void 0 : _e.itemInstanceID) !== null && _f !== void 0 ? _f : null,
                offHandItemInstanceID: (_h = (_g = update.offHandItemInstance) === null || _g === void 0 ? void 0 : _g.itemInstanceID) !== null && _h !== void 0 ? _h : null,
            });
            if (inventoryWorldMenu_1.inventoryWorldMenu.isOpen()) {
                inventoryWorldMenu_1.inventoryWorldMenu.state.setValues({
                    selectedBagItemIndex: null,
                    selectedEquipmentSlot: null,
                });
            }
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/exit-characters",
        onMessage: (update) => {
            for (const worldCharacterID of update.characterIDs) {
                const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, worldCharacterID);
                worldCharacter.remove();
            }
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/exit-to-main-menu",
        onMessage: (update) => {
            (0, closeWorldMenus_1.closeWorldMenus)();
            const worldState = (0, getWorldState_1.getWorldState)();
            const selfWorldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, worldState.values.worldCharacterID);
            selfWorldCharacter.player.character = null;
            for (const worldCharacter of (0, definables_1.getDefinables)(WorldCharacter_1.WorldCharacter).values()) {
                worldCharacter.remove();
            }
            for (const itemInstance of (0, definables_1.getDefinables)(ItemInstance_1.ItemInstance).values()) {
                itemInstance.remove();
            }
            const mainMenuCharacterIDs = [];
            for (const mainMenuCharacterUpdate of update.mainMenuCharacters) {
                mainMenuCharacterIDs.push(new MainMenuCharacter_1.MainMenuCharacter({
                    classID: mainMenuCharacterUpdate.classID,
                    clothesDyeItemID: mainMenuCharacterUpdate.clothesDyeItemID,
                    figureID: mainMenuCharacterUpdate.figureID,
                    hairDyeItemID: mainMenuCharacterUpdate.hairDyeItemID,
                    id: mainMenuCharacterUpdate.characterID,
                    level: mainMenuCharacterUpdate.level,
                    maskItemID: mainMenuCharacterUpdate.maskItemID,
                    outfitItemID: mainMenuCharacterUpdate.outfitItemID,
                    skinColorID: mainMenuCharacterUpdate.skinColorID,
                }).id);
            }
            state_1.state.setValues({
                mainMenuState: (0, createMainMenuState_1.createMainMenuState)({ mainMenuCharacterIDs }),
                selectedPlayerID: null,
                worldState: null,
            });
            (0, pixel_pigeon_1.exitLevel)();
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/inn",
        onMessage: () => {
            const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, (0, getWorldState_1.getWorldState)().values.worldCharacterID);
            worldCharacter.player.character.party.players.forEach((partyPlayer) => {
                var _a, _b;
                partyPlayer.worldCharacter.resources = {
                    hp: partyPlayer.worldCharacter.resources.maxHP,
                    maxHP: partyPlayer.worldCharacter.resources.maxHP,
                    maxMP: (_a = partyPlayer.worldCharacter.resources.maxMP) !== null && _a !== void 0 ? _a : null,
                    mp: (_b = partyPlayer.worldCharacter.resources.maxMP) !== null && _b !== void 0 ? _b : null,
                };
            });
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/move-characters",
        onMessage: (update) => {
            var _a, _b, _c;
            for (const worldMoveCharacterUpdate of update.characters) {
                const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, worldMoveCharacterUpdate.characterID);
                worldCharacter.resources =
                    typeof worldMoveCharacterUpdate.resources !== "undefined"
                        ? {
                            hp: worldMoveCharacterUpdate.resources.hp,
                            maxHP: worldMoveCharacterUpdate.resources.maxHP,
                            maxMP: (_a = worldMoveCharacterUpdate.resources.maxMP) !== null && _a !== void 0 ? _a : null,
                            mp: (_b = worldMoveCharacterUpdate.resources.mp) !== null && _b !== void 0 ? _b : null,
                        }
                        : null;
                worldCharacter.direction = worldMoveCharacterUpdate.direction;
                worldCharacter.isRenewing = (_c = worldMoveCharacterUpdate.isRenewing) !== null && _c !== void 0 ? _c : null;
                worldCharacter.step = worldMoveCharacterUpdate.step;
                (0, updateWorldCharacterOrder_1.updateWorldCharacterOrder)(worldCharacter.id, worldMoveCharacterUpdate.order);
                switch (worldCharacter.direction) {
                    case retrommo_types_1.Direction.Down:
                        worldCharacter.position = {
                            x: worldCharacter.position.x,
                            y: worldCharacter.position.y + 1,
                        };
                        break;
                    case retrommo_types_1.Direction.Left:
                        worldCharacter.position = {
                            x: worldCharacter.position.x - 1,
                            y: worldCharacter.position.y,
                        };
                        break;
                    case retrommo_types_1.Direction.Right:
                        worldCharacter.position = {
                            x: worldCharacter.position.x + 1,
                            y: worldCharacter.position.y,
                        };
                        break;
                    case retrommo_types_1.Direction.Up:
                        worldCharacter.position = {
                            x: worldCharacter.position.x,
                            y: worldCharacter.position.y - 1,
                        };
                        break;
                }
                worldCharacter.movedAt = (0, pixel_pigeon_1.getCurrentTime)();
            }
            for (const clearedMarkerWorldCharacterID of update.clearedMarkerWorldCharacterIDs) {
                const clearedMarkerWorldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, clearedMarkerWorldCharacterID);
                if (clearedMarkerWorldCharacter.hasMarkerEntity()) {
                    (0, clearWorldCharacterMarker_1.clearWorldCharacterMarker)(clearedMarkerWorldCharacterID);
                }
            }
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/open-bank",
        onMessage: (update) => {
            const bank = (0, definables_1.getDefinable)(Bank_1.Bank, update.bankID);
            bank.isOpen = true;
            bank.toggledAt = (0, pixel_pigeon_1.getCurrentTime)();
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/open-chest",
        onMessage: (update) => {
            (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, (0, getWorldState_1.getWorldState)().values.worldCharacterID).player.character.party.players.forEach((partyPlayer) => {
                if (partyPlayer.worldCharacter.openedChestIDs.includes(update.chestID) ===
                    false) {
                    partyPlayer.worldCharacter.openedChestIDs = [
                        ...partyPlayer.worldCharacter.openedChestIDs,
                        update.chestID,
                    ];
                }
            });
            (0, definables_1.getDefinable)(Chest_1.Chest, update.chestID).openedAt = (0, pixel_pigeon_1.getCurrentTime)();
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/marker",
        onMessage: (update) => {
            (0, addWorldCharacterMarker_1.addWorldCharacterMarker)(update.characterID, update.type);
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/piano-key",
        onMessage: (update) => {
            var _a;
            const worldState = (0, getWorldState_1.getWorldState)();
            const offset = (_a = update.sinceLastKey) !== null && _a !== void 0 ? _a : 0;
            let noteTime;
            if (update.pianoSessionID !== worldState.values.pianoSessionID) {
                noteTime = (0, pixel_pigeon_1.getCurrentTime)() + 1000;
            }
            else {
                if (worldState.values.lastPianoNoteAt === null) {
                    throw new Error("lastPianoNoteAt is null");
                }
                noteTime = worldState.values.lastPianoNoteAt + offset;
            }
            worldState.setValues({
                lastPianoNoteAt: noteTime,
                pianoNotes: [
                    ...worldState.values.pianoNotes,
                    {
                        index: update.index,
                        playAt: noteTime,
                        type: update.type,
                    },
                ],
                pianoSessionID: update.pianoSessionID,
            });
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/position",
        onMessage: (update) => {
            const worldState = (0, getWorldState_1.getWorldState)();
            for (const worldCharacter of (0, definables_1.getDefinables)(WorldCharacter_1.WorldCharacter).values()) {
                worldCharacter.remove();
            }
            for (const bagItemInstanceID of worldState.values.bagItemInstanceIDs) {
                const bagItemInstance = (0, definables_1.getDefinable)(ItemInstance_1.ItemInstance, bagItemInstanceID);
                bagItemInstance.remove();
            }
            (0, pixel_pigeon_1.goToLevel)(update.tilemapID);
            for (const worldCharacterUpdate of update.characters) {
                const worldCharacterUpdatePlayer = (0, definables_1.getDefinable)(Player_1.Player, worldCharacterUpdate.playerID);
                worldCharacterUpdatePlayer.worldCharacterID =
                    worldCharacterUpdate.characterID;
                (0, loadWorldCharacterUpdate_1.loadWorldCharacterUpdate)(worldCharacterUpdate);
                if (state_1.state.values.selectedPlayerID === worldCharacterUpdate.playerID) {
                    (0, addWorldCharacterMarker_1.addWorldCharacterMarker)(worldCharacterUpdate.characterID, retrommo_types_1.MarkerType.Selected);
                }
            }
            for (const worldNPCUpdate of update.npcs) {
                (0, loadWorldNPCUpdate_1.loadWorldNPCUpdate)(worldNPCUpdate);
            }
            for (const worldBagItemInstanceUpdate of update.bagItemInstances) {
                (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(worldBagItemInstanceUpdate);
            }
            worldState.setValues({
                bagItemInstanceIDs: update.bagItemInstances.map((itemInstanceUpdate) => itemInstanceUpdate.itemInstanceID),
            });
            (0, pixel_pigeon_1.lockCameraToEntity)((0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, (0, getWorldState_1.getWorldState)().values.worldCharacterID)
                .entityID);
            if (update.didTeleport === true) {
                (0, pixel_pigeon_1.playAudioSource)("sfx/teleport", {
                    volumeChannelID: volumeChannels_1.sfxVolumeChannelID,
                });
            }
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/select-quest",
        onMessage: (update) => {
            const worldState = (0, getWorldState_1.getWorldState)();
            const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, worldState.values.worldCharacterID);
            const isLeader = worldCharacter.player.character.party.playerIDs[0] ===
                worldCharacter.playerID;
            if (npcDialogueWorldMenu_1.npcDialogueWorldMenu.isOpen() === false) {
                (0, closeWorldMenus_1.closeWorldMenus)();
                npcDialogueWorldMenu_1.npcDialogueWorldMenu.open({
                    isLeader,
                    npcID: update.npcID,
                });
            }
            const npc = (0, definables_1.getDefinable)(NPC_1.NPC, update.npcID);
            npcDialogueWorldMenu_1.npcDialogueWorldMenu.state.setValues({
                questCompletion: null,
                selectedQuestIndex: typeof update.questID !== "undefined"
                    ? npc.questGiver.quests.findIndex((questGiverQuest) => questGiverQuest.questID === update.questID)
                    : null,
            });
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/sell-shop-item",
        onMessage: (update) => {
            const worldState = (0, getWorldState_1.getWorldState)();
            worldState.setValues({
                bagItemInstanceIDs: worldState.values.bagItemInstanceIDs.filter((bagItemInstanceID) => bagItemInstanceID !== update.itemInstanceID),
                inventoryGold: update.gold,
            });
            (0, definables_1.getDefinable)(ItemInstance_1.ItemInstance, update.itemInstanceID).remove();
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/start-battle",
        onMessage: () => {
            for (const worldCharacter of (0, definables_1.getDefinables)(WorldCharacter_1.WorldCharacter).values()) {
                worldCharacter.remove();
            }
            for (const itemInstance of (0, definables_1.getDefinables)(ItemInstance_1.ItemInstance).values()) {
                itemInstance.remove();
            }
            state_1.state.setValues({
                battleState: (0, createBattleState_1.createBattleState)(),
                worldState: null,
            });
            (0, pixel_pigeon_1.exitLevel)();
            if (selectedPlayerWorldMenu_1.selectedPlayerWorldMenu.isOpen()) {
                selectedPlayerWorldMenu_1.selectedPlayerWorldMenu.state.setValues({
                    isBattleStarting: true,
                });
            }
            (0, closeWorldMenus_1.closeWorldMenus)();
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/trade",
        onMessage: () => {
            for (const worldCharacter of (0, definables_1.getDefinables)(WorldCharacter_1.WorldCharacter).values()) {
                if (worldCharacter.hasMarkerEntity()) {
                    (0, clearWorldCharacterMarker_1.clearWorldCharacterMarker)(worldCharacter.id);
                }
            }
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/trade-complete",
        onMessage: (update) => {
            const worldState = (0, getWorldState_1.getWorldState)();
            for (const bagItemInstanceID of worldState.values.bagItemInstanceIDs) {
                const bagItemInstance = (0, definables_1.getDefinable)(ItemInstance_1.ItemInstance, bagItemInstanceID);
                bagItemInstance.remove();
            }
            for (const bagItemInstanceUpdate of update.bagItemInstances) {
                (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(bagItemInstanceUpdate);
            }
            worldState.setValues({
                bagItemInstanceIDs: update.bagItemInstances.map((itemInstanceUpdate) => itemInstanceUpdate.itemInstanceID),
                inventoryGold: update.gold,
            });
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/turn-characters",
        onMessage: (update) => {
            for (const turn of update.turns) {
                const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, turn.characterID);
                worldCharacter.direction = turn.direction;
            }
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/turn-npc",
        onMessage: (update) => {
            const worldState = (0, getWorldState_1.getWorldState)();
            const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, worldState.values.worldCharacterID);
            const isLeader = worldCharacter.player.character.party.playerIDs[0] ===
                worldCharacter.playerID;
            const npc = (0, definables_1.getDefinable)(NPC_1.NPC, update.npcID);
            npc.direction = update.direction;
            if (update.wasInteracted === true) {
                if (npc.hasDialogue() || npc.hasQuestGiver()) {
                    (0, closeWorldMenus_1.closeWorldMenus)();
                    npcDialogueWorldMenu_1.npcDialogueWorldMenu.open({
                        isLeader,
                        npcID: npc.id,
                    });
                }
            }
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "world/vanity",
        onMessage: (update) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            const worldState = (0, getWorldState_1.getWorldState)();
            if (typeof update.items !== "undefined") {
                for (const bagItemInstanceID of worldState.values.bagItemInstanceIDs) {
                    const bagItemInstance = (0, definables_1.getDefinable)(ItemInstance_1.ItemInstance, bagItemInstanceID);
                    bagItemInstance.remove();
                }
                if (worldState.values.clothesDyeItemInstanceID !== null) {
                    const clothesDyeItemInstance = (0, definables_1.getDefinable)(ItemInstance_1.ItemInstance, worldState.values.clothesDyeItemInstanceID);
                    clothesDyeItemInstance.remove();
                }
                if (worldState.values.hairDyeItemInstanceID !== null) {
                    const hairDyeItemInstance = (0, definables_1.getDefinable)(ItemInstance_1.ItemInstance, worldState.values.hairDyeItemInstanceID);
                    hairDyeItemInstance.remove();
                }
                if (worldState.values.maskItemInstanceID !== null) {
                    const maskItemInstance = (0, definables_1.getDefinable)(ItemInstance_1.ItemInstance, worldState.values.maskItemInstanceID);
                    maskItemInstance.remove();
                }
                if (worldState.values.outfitItemInstanceID !== null) {
                    const outfitItemInstance = (0, definables_1.getDefinable)(ItemInstance_1.ItemInstance, worldState.values.outfitItemInstanceID);
                    outfitItemInstance.remove();
                }
                for (const bagItemInstanceUpdate of update.items.bagItemInstances) {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(bagItemInstanceUpdate);
                }
                if (typeof update.items.clothesDyeItemInstance !== "undefined") {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.items.clothesDyeItemInstance);
                }
                if (typeof update.items.hairDyeItemInstance !== "undefined") {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.items.hairDyeItemInstance);
                }
                if (typeof update.items.maskItemInstance !== "undefined") {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.items.maskItemInstance);
                }
                if (typeof update.items.outfitItemInstance !== "undefined") {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.items.outfitItemInstance);
                }
                worldState.setValues({
                    bagItemInstanceIDs: update.items.bagItemInstances.map((bagItemInstanceUpdate) => bagItemInstanceUpdate.itemInstanceID),
                    clothesDyeItemInstanceID: (_b = (_a = update.items.clothesDyeItemInstance) === null || _a === void 0 ? void 0 : _a.itemInstanceID) !== null && _b !== void 0 ? _b : null,
                    hairDyeItemInstanceID: (_d = (_c = update.items.hairDyeItemInstance) === null || _c === void 0 ? void 0 : _c.itemInstanceID) !== null && _d !== void 0 ? _d : null,
                    maskItemInstanceID: (_f = (_e = update.items.maskItemInstance) === null || _e === void 0 ? void 0 : _e.itemInstanceID) !== null && _f !== void 0 ? _f : null,
                    outfitItemInstanceID: (_h = (_g = update.items.outfitItemInstance) === null || _g === void 0 ? void 0 : _g.itemInstanceID) !== null && _h !== void 0 ? _h : null,
                    worldCharacterID: update.characterID,
                });
                if (inventoryWorldMenu_1.inventoryWorldMenu.isOpen()) {
                    inventoryWorldMenu_1.inventoryWorldMenu.state.setValues({
                        selectedBagItemIndex: null,
                        selectedVanitySlot: null,
                    });
                }
            }
            const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, update.characterID);
            switch (update.slot) {
                case retrommo_types_1.VanitySlot.ClothesDye:
                    worldCharacter.clothesDyeItemID = (_j = update.vanityItemID) !== null && _j !== void 0 ? _j : null;
                    break;
                case retrommo_types_1.VanitySlot.HairDye:
                    worldCharacter.hairDyeItemID = (_k = update.vanityItemID) !== null && _k !== void 0 ? _k : null;
                    break;
                case retrommo_types_1.VanitySlot.Mask:
                    worldCharacter.maskItemID = (_l = update.vanityItemID) !== null && _l !== void 0 ? _l : null;
                    break;
                case retrommo_types_1.VanitySlot.Outfit:
                    worldCharacter.outfitItemID = (_m = update.vanityItemID) !== null && _m !== void 0 ? _m : null;
                    break;
            }
        },
    });
};
exports.listenForWorldUpdates = listenForWorldUpdates;
